import { useState } from "react";
import { ChevronLeft, ChevronRight, Maximize2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Art } from "./Art";
import { Reveal } from "./Reveal";

export const DRAWINGS = [
  ["Boundary Plan", "boundary"], ["Topographic Plan", "topo"], ["Contour Map", "contour"], ["As-Built Survey", "asbuilt"],
  ["Subdivision Drawing", "subdivision"], ["Utility Survey", "utility"], ["Coordinate-to-CAD Conversion", "conversion"], ["Point Cloud to CAD", "pointcloud"],
];

const Sheet = ({ title, kind, n, big = false }) => (
  <div className="relative bg-[#F7F9FB] p-2">
    <div className="border border-[#102A43]/50 p-1.5">
      <div className="border border-[#102A43]/25 grid grid-cols-[1fr_auto]">
        <div className="relative aspect-[400/260] bg-[linear-gradient(rgba(16,42,67,.05)_1px,transparent_1px),linear-gradient(90deg,rgba(16,42,67,.05)_1px,transparent_1px)] bg-[size:20px_20px]">
          <Art kind={kind} tone="paper" className="absolute inset-0 h-full w-full p-3" />
        </div>
        <div className={`border-l border-[#102A43]/25 flex flex-col justify-between font-mono text-[#102A43] ${big ? "w-40 p-3 text-[11px]" : "w-16 sm:w-20 p-1.5 text-[7px] sm:text-[8px]"}`}>
          <span className="font-bold tracking-wider">GEO DRAFTING</span>
          <span className="text-[#526579] leading-tight">{title.toUpperCase()}</span>
          <span className="text-[#1769AA]">SHT {String(n).padStart(2, "0")}</span>
        </div>
      </div>
    </div>
  </div>
);

export const Gallery = () => {
  const [idx, setIdx] = useState(null);
  const go = (d) => setIdx((i) => (i + d + DRAWINGS.length) % DRAWINGS.length);
  const cur = idx === null ? null : DRAWINGS[idx];
  return (
    <>
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-testid="drawing-gallery">
        {DRAWINGS.map(([t, k], i) => (
          <Reveal key={t} delay={(i % 4) * 0.07}>
            <button type="button" onClick={() => setIdx(i)} data-testid={`gallery-item-${k}`} className="group block w-full text-left">
              <div className="relative overflow-hidden transition-transform duration-500 group-hover:-translate-y-1">
                <Sheet title={t} kind={k} n={i + 1} />
                <span className="absolute right-3 top-3 grid h-8 w-8 place-items-center bg-[#102A43] text-white opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100"><Maximize2 className="h-4 w-4" /></span>
              </div>
              <div className="mt-3 flex items-baseline justify-between gap-3">
                <span className="font-display font-bold text-white group-hover:text-[#5AA9E6] transition-colors">{t}</span>
                <span className="font-mono text-[10px] tracking-widest text-[#D8B66A] shrink-0">ILLUSTRATIVE</span>
              </div>
            </button>
          </Reveal>
        ))}
      </div>
      <Dialog open={idx !== null} onOpenChange={(o) => !o && setIdx(null)}>
        <DialogContent className="max-w-5xl rounded-none border-[#1769AA]/40 bg-[#0A1D30] p-4 sm:p-6 text-white" data-testid="gallery-viewer">
          {cur && (
            <>
              <DialogTitle className="font-display text-xl">{cur[0]}</DialogTitle>
              <DialogDescription className="font-mono text-[11px] tracking-widest text-[#D8B66A]">ILLUSTRATIVE DEMONSTRATION — NOT CLIENT WORK</DialogDescription>
              <Sheet title={cur[0]} kind={cur[1]} n={idx + 1} big />
              <div className="flex items-center justify-between">
                <button type="button" onClick={() => go(-1)} data-testid="gallery-prev-button" className="btn btn-ghost !py-2.5"><ChevronLeft className="h-4 w-4" />Prev</button>
                <span className="font-mono text-xs text-[#9fb3c8]">{idx + 1} / {DRAWINGS.length}</span>
                <button type="button" onClick={() => go(1)} data-testid="gallery-next-button" className="btn btn-ghost !py-2.5">Next<ChevronRight className="h-4 w-4" /></button>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
